/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ct_Upwork_LabelInputs */

const en_ct_upwork_label = /** @type {(inputs: Ct_Upwork_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hire on Upwork`)
};

const ar_ct_upwork_label = /** @type {(inputs: Ct_Upwork_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وظّفني على Upwork`)
};

const bn_ct_upwork_label = /** @type {(inputs: Ct_Upwork_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upwork-এ হায়ার`)
};

const de_ct_upwork_label = /** @type {(inputs: Ct_Upwork_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über Upwork beauftragen`)
};

const es_ct_upwork_label = /** @type {(inputs: Ct_Upwork_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contratar en Upwork`)
};

const fr_ct_upwork_label = /** @type {(inputs: Ct_Upwork_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embaucher sur Upwork`)
};

const pt_ct_upwork_label = /** @type {(inputs: Ct_Upwork_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrate no Upwork`)
};

const zh_ct_upwork_label = /** @type {(inputs: Ct_Upwork_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Upwork 上招聘`)
};

const tr_ct_upwork_label = /** @type {(inputs: Ct_Upwork_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upwork'te İşe Alma`)
};

const ru_ct_upwork_label = /** @type {(inputs: Ct_Upwork_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нанимайте на Upwork`)
};

const pl_ct_upwork_label = /** @type {(inputs: Ct_Upwork_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatrudnij w Upwork`)
};

/**
* | output |
* | --- |
* | "Hire on Upwork" |
*
* @param {Ct_Upwork_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const ct_upwork_label = /** @type {((inputs?: Ct_Upwork_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ct_Upwork_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ct_upwork_label(inputs)
	if (locale === "bn") return bn_ct_upwork_label(inputs)
	if (locale === "de") return de_ct_upwork_label(inputs)
	if (locale === "es") return es_ct_upwork_label(inputs)
	if (locale === "fr") return fr_ct_upwork_label(inputs)
	if (locale === "pt") return pt_ct_upwork_label(inputs)
	if (locale === "zh") return zh_ct_upwork_label(inputs)
	if (locale === "tr") return tr_ct_upwork_label(inputs)
	if (locale === "ru") return ru_ct_upwork_label(inputs)
	if (locale === "pl") return pl_ct_upwork_label(inputs)
	return en_ct_upwork_label(inputs)
});